import _regeneratorRuntime from 'babel-runtime/regenerator';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import { v4 as uuidV4 } from 'uuid';
import { initEveClient, logSegment, setSessionAttributes } from '@rosetta/eve-client';
import { GaiaApolloClient } from '../gaia-data/apolloClient';
import { FeatureFlagsQuery } from './apollo/user-graphql';
import { getConfig } from '../gaia-data/init';
import { version } from '../../../package.json';

export function getToken(username, password) {
  var uri = getConfig().serverUrl + '/login';
  var body = { username: username, password: password };
  var options = {
    method: 'POST',
    headers: {
      accept: 'application/json',
      'cache-control': 'no-cache',
      'Content-Type': 'application/json',
      'X-Request-ID': uuidV4()
    },
    body: _JSON$stringify(body)
  };
  return fetch(uri, options).then(function (response) {
    if (response.status === 200) {
      return response;
    } else {
      var error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
  }).then(function (response) {
    return response.json();
  });
}

export function getTokenByRefreshToken(refreshToken) {
  var uri = getConfig().serverUrl + '/refreshToken/' + refreshToken;
  var options = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      'cache-control': 'no-cache',
      'X-Request-ID': uuidV4()
    }
  };
  return fetch(uri, options).then(function (response) {
    return response;
  }).then(function (response) {
    if (response.status === 200) {
      return response.json();
    } else {
      return false;
    }
  });
}

export function getUserJsonFromToken(token) {
  var uri = getConfig().serverUrl + '/validateToken';
  var options = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      'cache-control': 'no-cache',
      'X-Request-ID': uuidV4(),
      authorization: 'Bearer ' + token
    }
  };
  return fetch(uri, options).then(function (response) {
    return response;
  }).then(function (response) {
    if (response.status === 200) {
      return response.json();
    } else {
      return false;
    }
  });
}

export function initEve(userJson) {
  if (userJson.eve && userJson.eve.jwtToken && userJson.eve.host) {
    var application = getConfig().appName || 'Unconfigured (appName) Gaia Client';

    initEveClient(userJson.eve.host, userJson.eve.jwtToken, userJson.userId, userJson.organization, application, version);

    var product = void 0;
    if (userJson.products.productRights[0]) {
      product = userJson.products.productRights[0].salesPackageId;
    }
    if (!product) {
      product = application;
    }
    setSessionAttributes({
      product: product,
      locale: userJson.egoUser.interfaceLanguage
    });

    logSegment('application-startup', application + '-eve-inited');
  }
}

export function getFeatureFlags() {
  var data;
  return _regeneratorRuntime.async(function getFeatureFlags$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _regeneratorRuntime.awrap(GaiaApolloClient.query({ query: FeatureFlagsQuery }));

        case 2:
          data = _context.sent;
          return _context.abrupt('return', data.data.featureFlags !== null ? data.data.featureFlags.map(function (flag) {
            return flag.feature;
          }) : []);

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, null, this);
}

export function clearTokens() {
  sessionStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
}